<template>
    <div id="datatypesdropdown_main">
        <label for="datatypesdropdown_head" class="fs-small">Datatype</label>
        <div id="datatypesdropdown_head" class="bg-faded fs-small" @click="open = !open">
            {{ datatypes[selectedId] }}
            <i class="fas fa-caret-down fc-gray-dark"></i>
        </div>
        <div v-if="open" id="datatypesdropdown_body" class="shadow-1 bg-white">
            <div class="datatypesdropdown_datatype bt-hover-dark bg-white" v-for="(datatype, index) in datatypes" :key="datatype.id" @click="choose(index)">
                {{ datatype }}
            </div>
        </div>
    </div>
</template>

<script>
  export default {
    name: 'datatypesDropdown',
    props: {
      selectedId: {
        type: String,
        default: 1
      }
    },
    data(){
      return{
        open: false,
        datatypes: {
          1: 'String',
          2: 'Number',
          3: 'Boolean'
        }
      }
    },
    methods: {
      choose(data){
        this.$emit('input', data);
        this.open = false;
      }
    }
  }
</script>

<style scoped>
    #datatypesdropdown_main{
        display: flex;
        width: 100%;
        flex-direction: column;
        position: relative;
    }
    #datatypesdropdown_head{
        display: flex;
        width: calc(100% - 10px);
        height: 20px;
        border: 1px solid var(--color-gray);
        padding: 5px;
        justify-content: space-between;
        align-items: center;
    }
    #datatypesdropdown_body{
        display: flex;
        flex-direction: column;
        width: 100%;
        padding-top: 10px;
        padding-bottom: 10px;
        margin-left: 1px;
        position: absolute;
        top: 50px;
    }
    .datatypesdropdown_datatype{
        display: flex;
        padding-left: 20px;
        padding-top: 5px;
        padding-bottom: 5px;
    }
</style>
